import { Download } from '../../lib/context/DownloadContext';
import BrSplitter from '../../lib/helpers/BrSplitter';
import { P2GGrid, P2GBox, P2GChip, P2GIcon, P2GLink, SvgClose } from '@parcel2go/core-ui';

interface props {
  download: Download;
  onClick?: () => void;
  onRemove?: () => void;
}

export function DownloadRowView(props: props) {
  return (
    <P2GGrid container alignItems="center" spacing={1}>
      <P2GGrid item>
        <P2GBox pt={1} pb={1}>
          {props.download.Href ? (
            <P2GLink target="_blank" href={props.download.Href} underline={'always'}>
              <BrSplitter label={props.download.Label} />
            </P2GLink>
          ) : (
            <P2GLink href="javascript:void(0)" onClick={props.onClick}>
              <BrSplitter label={props.download.Label} />
            </P2GLink>
          )}
        </P2GBox>
      </P2GGrid>
      {props.onRemove && <P2GGrid item flexGrow={1}></P2GGrid>}
      <P2GGrid item>
        {props.download.Status && (
          <P2GChip
            label={props.download.Status}
            color={props.download.Status === 'Processing' ? 'info' : 'success'}
            size="small"
          />
        )}
      </P2GGrid>
      {props.onRemove && (
        <P2GGrid item flexShrink={1}>
          <P2GIcon onClick={props.onRemove} palette="primary">
            <SvgClose />
          </P2GIcon>
        </P2GGrid>
      )}
    </P2GGrid>
  );
}
